import { render, staticRenderFns } from "./Transfusion.vue?vue&type=template&id=dad0e3de&scoped=true&"
import script from "./Transfusion.vue?vue&type=script&lang=js&"
export * from "./Transfusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad0e3de",
  null
  
)

export default component.exports